import React from 'react';

import { forwardRef, Text as ChakraText } from '@chakra-ui/react';

import { TextSize21, TextV21Props } from '../../types';

const DEFAULT_SIZE: TextSize21 = 'body-md';

/**
 * DLS 2.1 (legacy) Text — the t-shirt scale, unchanged.
 *
 * `data-dls-version="2.1"` is what the themes' `versionedStyleConfig` keys off to resolve the
 * 2.1 styles; the dispatcher passes it. The default size is passed as a prop rather than left
 * to the theme, because the merged style-config's `defaultProps` come from the current (2.2)
 * version — around 500 call sites render `<Text>` with no `size` at all and rely on this.
 */
export const TextV21 = forwardRef<TextV21Props, 'p'>((props, ref) => {
  const { size = DEFAULT_SIZE, ...rest } = props;

  return <ChakraText ref={ref} size={size} {...rest} />;
});

TextV21.displayName = 'Text';
